export class IdentityStructuralTransformer {
    transform(sourcedValueOptions) {
        return sourcedValueOptions;
    }
}
//# sourceMappingURL=IdentityStructuralTransformer.js.map